import { useEffect, useState } from "react";
import {
  calculatorthird,
  calculatortwo,
  calGif,
  calOff,
  Comission,
  union,
} from "../../assets/assets";
import httpApiCall from "../../service/api.service";
import CurrencyFormatter, {
  formatCurrencyUSA,
} from "../../utils/CurrencyFormatter";
import Tier from "./Tier";
import "./Calculator.scss";
import { useSelector } from "react-redux";
import React from "react";
import { useNavigate } from "react-router-dom";

const Calculator = React.memo(() => {
  const navigate = useNavigate();
  const profildata = useSelector((state: any) => state?.APIData?.partnerData);
  const partnerSetting =
    profildata &&
    profildata?.partner_profile &&
    profildata?.partner_profile[0] &&
    profildata?.partner_profile[0].partner_settings &&
    profildata?.partner_profile[0].partner_settings[0];

  const currency = useSelector(
    (state: any) => state?.APIData?.partnerData.country_currency_info?.currency
  );

  const questionArr = [
    {
      title:
        "What is your monthly target for registering or onboarding businesses into the program?",
      min_val: 1,
      max_val: 20,
      key: "partner_can_add_bs",
      id: 1,
    },
    {
      title:
        "How many payment plans is each business expected to generate monthly?",
      min_val: 1,
      max_val: 20,
      default_val: 25,
      key: "bs_can_generate_payment",
      id: 2,
    },
    {
      title:
        "What is the anticipated average monthly recurring amount for each payment plan?",
      min_val: 1,
      max_val: 2000,
      default_val: 100,
      key: "recurring_amt_per_mt",
      id: 3,
    },
  ];
  const [questions, setQuestions] = useState(questionArr);

  const [index, setIndex] = useState<any>();
  const Steps = {
    STEP_1: 1,
    STEP_2: 2,
    STEP_3: 3,
    STEP_4: 4,
  };

  useEffect(() => {
    if (partnerSetting && partnerSetting?.share_type == 2) {
      setQuestions(questions.slice(0, 2));
    }
  }, [partnerSetting]);
  const [step, setStep] = useState(Steps.STEP_1);
  const [loader, setloader] = useState(false);
  const [isEarnMore, setIsEarnMore] = useState(false);
  const [inputs, setInputs] = useState<{ [key: string]: any }>({
    slider1: 5,
    slider2: 5,
    slider3: 400,
    slider4: 5,
  });
  const [greyClipPaths, setGreyClipPaths] = useState<string[]>([]);
  const [blueClipPaths, setBlueClipPaths] = useState<string[]>([]);
  const [earn, setEarn] = useState();
  let accessToken: any = localStorage.getItem("partner_storage");
  const getProfile = JSON.parse(accessToken).partnerProfile[0];

  const handleSliderChange = (event: any, id: number, maxValue?: any) => {
    const { value, name } = event.target;
    const parsedValue = parseFloat(value);

    if (!isNaN(parsedValue)) {
      let range: number = parsedValue;
      range =
        id === 4
          ? Math.min(Math.max(range, 1), 10)
          : Math.min(Math.max(range, 1), maxValue);

      setInputs((prevInputs) => ({
        ...prevInputs,
        [name]: range,
      }));

      const blueWidthPercentage =
        id === 4
          ? ((range - 1) / (10 - 1)) * 100
          : ((range - 1) / (maxValue - 1)) * 100;
      // console.log(blueWidthPercentage, "blueWidthPercentage");

      const percentage = blueWidthPercentage ?? 0;

      const newBlueClipPaths = [...blueClipPaths];
      newBlueClipPaths[
        id
      ] = `polygon(0 0, ${percentage}% 0, ${percentage}% 100%, 0% 100%)`;
      setBlueClipPaths(newBlueClipPaths);

      const newGreyClipPaths = [...greyClipPaths];
      newGreyClipPaths[
        id
      ] = `polygon(${percentage}% 0, 100% 0, 100% 100%, ${percentage}% 100%)`;
      setGreyClipPaths(newGreyClipPaths);
    } else {
      setInputs((prevInputs) => ({
        ...prevInputs,
        [name]: "",
      }));
      const blueWidthPercentage = 0;
      // console.log(blueWidthPercentage,"blueWidthPercentage");

      const percentage = blueWidthPercentage ?? 0;

      const newBlueClipPaths = [...blueClipPaths];
      newBlueClipPaths[
        id
      ] = `polygon(0 0, ${percentage}% 0, ${percentage}% 100%, 0% 100%)`;
      setBlueClipPaths(newBlueClipPaths);

      const newGreyClipPaths = [...greyClipPaths];
      newGreyClipPaths[
        id
      ] = `polygon(${percentage}% 0, 100% 0, 100% 100%, ${percentage}% 100%)`;
      setGreyClipPaths(newGreyClipPaths);

      // console.error('Invalid input value');
    }
  };

  const handleNextButtonClick = (i: any) => {
    if (inputs[`slider${i}`] < 1) {
      return;
    } else {
      if (i == 0) {
        const elementsToShow = ["1", "2", "3"];

        elementsToShow.forEach((id) => {
          const element = document.getElementById(id);
          if (element) {
            element.classList.remove("hide");
          }
        });
      }

      if (i == 2) {
        const currentWrapper = document.getElementById("1");
        if (currentWrapper) {
          currentWrapper.classList.add("hide");
        }
      }
      if (partnerSetting?.share_type === 2 ? i == 2 : i == 3) {
        comission();
        return;
      }
      setIndex(i);
      const currentWrapper = document.getElementById(i);
      if (!currentWrapper) return;
      currentWrapper.classList.add("hide");
      currentWrapper.nextElementSibling?.classList.remove("hide");
      const nextElement = currentWrapper.nextElementSibling;

      if (nextElement) {
        nextElement.classList.remove("hide");
      }
    }
  };

  const comission = async (i?: any) => {
    if (inputs[`slider${i}`] < 1) {
      return;
    } else {
      setloader(true);
      const body: any = {
        businessEachMonth: inputs.slider1,
        paymentPlansEachMonth: inputs.slider2,
        avgRecurringPerMonth: inputs.slider3,
        access_token: getProfile.access_token,
      };
      if (
        partnerSetting &&
        (partnerSetting?.share_type === 2 || partnerSetting?.share_type === 3)
      ) {
        body.fixed_share_value =
          partnerSetting && partnerSetting.fixed_share_value;
      }

      const newbody = { ...body, subPartnersCount: inputs.slider4 };

      await httpApiCall({
        api: "partner_calculator",
        type: "POST",
        body: isEarnMore ? newbody : body,
      })
        .then((data) => {
          setTimeout(() => {
            setloader(false);
            if (data && !data.is_error) {
              setEarn(data);
              if (i == Steps.STEP_4) {
                setStep(Steps.STEP_3);
              } else {
                setStep(Steps.STEP_2);
              }
            }
          }, 3500);
        })
        .catch((error) => {
          console.error(
            "There was a problem with the calculator params:",
            error
          );
        });
    }
  };

  return (
    <>
      {partnerSetting && partnerSetting.share_type == 0 && (
        <div className="statement_box-container">
        <div className="statement_box py-3">
          <img src={calOff} alt="" className="mb-3" />
          <h5 style={{ fontWeight: 600 }}>
            The calculator feature is currently not enabled on your panel.
          </h5>
          <h6 style={{ fontWeight: 600 }}>
            Please reach out to our <span
              className="link pointer"
              style={{ color: "#013d50", cursor: "pointer", fontWeight: 700 }}
              onClick={() => navigate("/app/support")}
            >
               support team
            </span>{" "}
            to have it enabled.
          </h6>
        </div>
      </div>
      )}

      {partnerSetting && partnerSetting.share_type != 0 && (
        <>
          <div className="-d-none d-lg-block">
            {loader && (
              <div className="cal-gif">
                <img src={calGif} alt="" />
              </div>
            )}

            {step == Steps.STEP_1 && (
              <div className="calc right-wrapper cal-wrap">
                <div className="calculator ">
                  {questions.map((i: any) => (
                    <div className="calculator-wrapper" id={i.id} key={i.id}>
                      <div className="calculator-one">
                        <p className="qnumber">Question {i.id}</p>
                        <h5 className="qusetion">{i.title}</h5>
                        <div className="d-flex align-items-center justify-content-between">
                          <div>
                            {i.id == Steps.STEP_3 && (
                              <span className="dollar">
                                {currency && currency[0]?.display_logo}
                              </span>
                            )}
                            <input
                              className={`qvalue ${
                                i.id === Steps.STEP_3 ? "inputWidth" : ""
                              }`}
                              type="text"
                              value={inputs[`slider${i.id}`]}
                              name={`slider${i.id}`}
                              onChange={(e: any) =>
                                handleSliderChange(e, i.id, i.max_val)
                              }
                            />
                          </div>

                          {partnerSetting &&
                            partnerSetting?.share_type == 2 &&
                            i.id == 2 && (
                              <div>
                                <p className="mb-0">
                                  Fixed Commission:{" "}
                                  {formatCurrencyUSA(
                                    partnerSetting &&
                                      partnerSetting.fixed_share_value *
                                        inputs[`slider${i.id}`]
                                  )}
                                </p>
                              </div>
                            )}
                        </div>

                        <div className="range-slider">
                          <div className="question--icon">
                            <img
                              src={
                                index == 1
                                  ? calculatortwo
                                  : index == 2
                                  ? calculatorthird
                                  : union
                              }
                            />
                          </div>
                          <input
                            className="slider"
                            type="range"
                            min={i.min_val}
                            max={i.max_val}
                            name={`slider${i.id}`}
                            value={
                              inputs["slider" + i.id]
                                ? inputs["slider" + i.id]
                                : 1
                            }
                            onChange={(e: any) =>
                              handleSliderChange(e, i.id, i.max_val)
                            }
                          />
                          <div
                            className="slider--wrap blue"
                            style={{
                              clipPath:
                                blueClipPaths[i.id] ||
                                "polygon(0px 0px, 21.0526% 0px, 21.0526% 100%, 0% 100%",
                            }}
                          ></div>
                          <div
                            className="slider--wrap grey"
                            style={{
                              clipPath:
                                greyClipPaths[i.id] ||
                                "polygon(21.0526% 0px, 100% 0px, 100% 100%, 21.0526% 100%",
                            }}
                          ></div>
                          <div className="d-flex justify-content-between mb-3">
                            <span className="rang--slider--val">
                              {i.id == 3
                                ? currency &&
                                  currency[0]?.display_logo + i.min_val
                                : i.min_val}
                            </span>
                            <span className="rang--slider--val">
                              {i.id == 3
                                ? currency &&
                                  currency[0]?.display_logo + i.max_val
                                : i.max_val}
                            </span>
                          </div>
                        </div>
                        <div className="next-question">
                          <button onClick={() => handleNextButtonClick(i.id)}>
                            Next
                            <span>
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0234 4.9397L17.0818 9.99803L12.0234 15.0564"
                                  stroke="white"
                                  strokeWidth="2"
                                  strokeMiterlimit="10"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M2.91797 9.99805H16.943"
                                  stroke="white"
                                  strokeWidth="2"
                                  strokeMiterlimit="10"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </button>
                        </div>
                      </div>
                      <div
                        onClick={() => {
                          handleNextButtonClick(i.id - 1);
                        }}
                        className={
                          "v-box " +
                          ((index == 1 && i.id == 2) ||
                          (i.id == 3 && index == 2)
                            ? "active"
                            : "")
                        }
                      >
                        <span>Q{i.id}</span>
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            width="25"
                            height="25"
                            rx="12.5"
                            fill="#18B557"
                          />
                          <path
                            d="M8.5 12.2723L11.345 15.1384L16.7764 9.66675"
                            stroke="white"
                            strokeWidth="1.3794"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {step == Steps.STEP_2 && (
              <>
                <div className="p-4 pb-0 back">
                  <button
                    onClick={() => {
                      setStep(Steps.STEP_1);
                      setIndex(0);
                    }}
                    className="mb-0 border-0 bg-transparent"
                  >
                    {" "}
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.37998 3.95312L2.33331 7.99979L6.37998 12.0465"
                        stroke="#292D32"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.6667 8H2.44666"
                        stroke="#292D32"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Back
                  </button>
                </div>
                <div className="main-calc">
                  <div className="earning ">
                    <div className="earning--info">
                      <div className="earning--label">
                        Amazing! You Will Earn
                      </div>
                      <div className="earning--amt" translate="no">
                        <CurrencyFormatter
                          amount={
                            earn &&
                            earn["stats"]["firstMonthCommission"] +
                              earn["statsFixed"]["firstMonthCommission"]
                          }
                        />
                        {}
                      </div>
                      <div className="earning--commission">
                        First Month Commission
                      </div>

                      <ul>
                        <li className="w-100 mb-1 ps-2">
                          <i>
                            *If you continue adding the following numbers each
                            month
                          </i>
                        </li>
                        <li className="earning--badge">
                          <span translate="no">
                            {" "}
                            {earn && earn["stats"]["totalBusinesses"]}
                          </span>{" "}
                          Businesses
                        </li>
                        <li className="earning--badge">
                          <span translate="no">
                            {" "}
                            {earn &&
                              earn["stats"]["totalPaymentPlans"] /
                                earn["stats"]["totalBusinesses"]}
                          </span>{" "}
                          Payment Plans/business
                        </li>
                       { partnerSetting.share_type !=2 && <li className="earning--badge">
                          <span translate="no">
                            <CurrencyFormatter
                              amount={
                                earn && earn["stats"]["avgRecurringPerMonth"]
                              }
                            />
                          </span>
                          Avg. recurring
                        </li>}
                      </ul>
                      <div className="earning--yearend pt-2">
                        Your Year End Commission Will Be
                        <span translate="no">
                          <CurrencyFormatter
                            amount={
                              earn &&
                              earn["stats"]["yearEndCommission"] +
                                earn["statsFixed"]["yearEndCommission"]
                            }
                          />
                        </span>
                      </div>
                    </div>
                    <div className="earning--img">
                      <img src={Comission} alt="" />
                    </div>
                  </div>

                  {!isEarnMore && (
                    <div className="mt-4 border-top pt-4">
                      <div className="earning--label mb-0">
                        Refer Partners And Earn More Commission!
                      </div>
                      <p className="-mb-0">
                        Refer sub-partners and earn additional commissions from
                        Credee.
                      </p>
                      <button
                        className="earn-btn"
                        onClick={() => {
                          setIsEarnMore(true);
                        }}
                      >
                        Earn More{" "}
                      </button>
                    </div>
                  )}

                  {isEarnMore && (
                    <div className="slag mt-4 border-top pt-4">
                      <div className="question--box">
                        <span className="label--black">
                          Refer sub-partners and earn additional commissions
                          from Credee.
                        </span>
                        <h2 className="question--heading">
                          How many partners could you add under your partner
                          account each month?
                        </h2>
                        <input
                          type="text"
                          className="question--value ms-0"
                          value={inputs[`slider${Steps.STEP_4}`]}
                          name={`slider${Steps.STEP_4}`}
                          onChange={(e: any) =>
                            handleSliderChange(e, Steps.STEP_4)
                          }
                        />

                        <div className="rang--slider">
                          <div className="question--icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="13"
                              height="34"
                              viewBox="0 0 13 34"
                              fill="none"
                            >
                              <path
                                d="M11.2966 5.17489C11.2966 7.75982 9.13943 9.84978 6.47142 9.84978C3.8034 9.84978 1.64626 7.75982 1.64626 5.17489C1.64626 2.58996 3.8034 0.5 6.47142 0.5C9.13943 0.5 11.2966 2.58996 11.2966 5.17489ZM12.9428 13.4799C12.9428 12.7101 12.3182 12.1598 11.5803 12.1598L1.36254 12.1603C0.567946 12.1603 0 12.7654 0 13.4804V23.6L2.44087 24.7001V33.5H10.5587V24.7001L12.9995 23.6L13 13.4799L12.9428 13.4799Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                          <input
                            type="range"
                            min={1}
                            max={10}
                            className="slider"
                            name={`slider${Steps.STEP_4}`}
                            value={
                              inputs["slider" + Steps.STEP_4]
                                ? inputs["slider" + Steps.STEP_4]
                                : 1
                            }
                            onChange={(e: any) =>
                              handleSliderChange(e, Steps.STEP_4)
                            }
                          />
                          <div
                            className="slider--wrap blue"
                            style={{
                              clipPath:
                                blueClipPaths[Steps.STEP_4] ||
                                "polygon(0px 0px, 44.4444% 0px, 44.4444% 100%, 0% 100%",
                            }}
                          ></div>
                          <div
                            className="slider--wrap grey"
                            style={{
                              clipPath:
                                greyClipPaths[Steps.STEP_4] ||
                                "polygon(44.4444% 0px, 100% 0px, 100% 100%, 44.4444% 100%",
                            }}
                          ></div>
                        </div>

                        <div className="d-flex justify-content-between rang--slider--val-wrapper">
                          <span className="rang--slider--val">1</span>
                          <span className="rang--slider--val">10</span>
                        </div>
                      </div>
                      <button
                        className="button border-0 earn-btn"
                        onClick={() => comission(4)}
                      >
                        Earn More
                        <span className="ms-2">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.0254 4.93994L17.0837 9.99827L12.0254 15.0566"
                              stroke="white"
                              strokeWidth="2"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M2.91602 9.99805H16.941"
                              stroke="white"
                              strokeWidth="2"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}

            {step == Steps.STEP_3 && (
              <div className="right-wrapper">
                <Tier data={earn} getback={() => setStep(Steps.STEP_2)} />
              </div>
            )}
          </div>
        </>
      )}

      {/* <div className="mobil-calc">
        <div>
          <input type="range" />
        </div>
      </div> */}
    </>
  );
});
export default Calculator;
